var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import id from "@irati/utils/id";
import HeaderLink from "./HeaderLink";
import { PopupBox, MenuIcon, ProfilePicture } from "./styled";
var HeaderMenu = /** @class */ (function (_super) {
    __extends(HeaderMenu, _super);
    function HeaderMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: false
        };
        _this.handleOutsideclick = function (_a) {
            var target = _a.target;
            if (!_this.container.contains(target)) {
                _this.hide();
            }
        };
        _this.show = function () {
            _this.setState({ show: true });
        };
        _this.hide = function () {
            _this.setState({ show: false });
        };
        _this.toggle = function () {
            _this.setState({ show: !_this.state.show });
        };
        _this.getPopupPosition = function () {
            var rect = _this.container.getBoundingClientRect();
            return {
                left: rect.left - 5 + "px",
                // bottom of element - scroll pos - 10
                top: rect.bottom - rect.y - 10 + "px"
            };
        };
        _this.showMenuIcon = function () {
            var label = _this.props.label;
            return typeof label === "string";
        };
        return _this;
    }
    HeaderMenu.prototype.componentDidMount = function () {
        window.addEventListener("click", this.handleOutsideclick);
    };
    HeaderMenu.prototype.componentWillUnmount = function () {
        window.removeEventListener("click", this.handleOutsideclick);
    };
    HeaderMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, user = _a.user;
        var show = this.state.show;
        var idNamespace = id("desktop", this.props);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: idNamespace, ref: function (c) {
                    _this.container = c;
                } },
                React.createElement(HeaderLink, { id: id("menu-toggle", idNamespace), onClick: this.toggle },
                    user && React.createElement(ProfilePicture, { id: id("user-profile", idNamespace), user: user, small: true }),
                    label,
                    this.showMenuIcon() && React.createElement(MenuIcon, { id: id("icon", idNamespace) }))),
            show && React.createElement(PopupBox, __assign({}, this.props, { style: this.getPopupPosition() }))));
    };
    return HeaderMenu;
}(Component));
export default HeaderMenu;
